

import { diagramToAnalyticsItem, formatPrice, removeHtml } from '@/utils/helpers'
import analytics from '@/mixins.js/analytics'

export default {
  filters: { formatPrice },
  mixins: [analytics],
  props: {
    diagrams: {
      type: Array,
      required: true
    },
    tags: {
      type: Array,
      required: false,
      default: () => []
    },
    diagramName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Related products'
    },
    showTags: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 3
    },
    showActions: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    listName () {
      return 'related_diagrams ' + this.diagramName
    }
  },
  mounted () {
    this.$gtag.event(
      'view_item_list', {
        items: this.diagrams.map((diagram, index) => ({
          ...diagramToAnalyticsItem(diagram, index),
          list_name: this.listName
        }))
      }
    )
  },
  methods: {
    removeHtml (value) {
      return removeHtml(value)
    },
    trackNextPage (value) {
      this.trackEvent(this.title, value)
    },
    trackCarouselClick (value) {
      this.trackEvent(this.title, `Click ${value.diagram}`)
    }
  }
}
